import React from 'react';
import Sidebar from './Sidebar';
import './LandingPage.css';

const LandingPage: React.FC = () => {
  return (
    <div className="landing-page">
      <Sidebar />

      <main className="main-content">
        <div className="chart-container">
          <img 
            src="/plots/department_trend/landing_page_plot.png"
            alt="Department Overview"
            className="landing-plot"
          />
        </div>
      </main>
    </div>
  );
};

export default LandingPage;
